import React from "react";

const FourchetteIcon = ({ className, style }) => {
return (
    <svg className={className} style={style} xmlns="http://www.w3.org/2000/svg" width="42.916" height="9.379" viewBox="0 0 42.916 9.379"><path d="M0 4.151l24.678-.154 4.728-4 13.4.308v.909l-10.069.529v.839l10.179.323v.958l-10.335.346v.81l10.223-.1.112.958-10.259.765v.81l10.259-.365v.909L29.294 9.38l-4.616-3.383H0z" fill="currentColor"/></svg>
)}

export default FourchetteIcon;
